import Notification from "@Features/notification/components/Notification";
import React from "react";
import IconExclamationCircle from "@Icons/IconExclamationCircle";
import Column from "@Containers/components/Column";
import {useTranslation} from "@Translation/hooks/useTranslation";

/**
 * Notification for the user that the vehicle is automatically preselected for the return trip as well
 */
function VehiclePreselectedForReturnTripNotification() {
    const {
        title: titleLabel,
        description: descriptionLabel,
    } = useTranslation("check_order.addons.JADL.vehicle.preselected_return")

    return (
        <Notification
            notificationType="blue"
            additionalClass="gb--row"
            isFullWidth
            notificationIcon={<IconExclamationCircle fill="#4a79e2"/>}
        >
            <Column>
                <span className="gb--emphasize">
                    {titleLabel}
                </span>
                <span>
                    {descriptionLabel}
                </span>
            </Column>
        </Notification>
    )
}

export default VehiclePreselectedForReturnTripNotification